import { gql } from "@apollo/client";

export const CREATE_PRORROGAS = gql`
    mutation createProrrogas(
        $input : [ProrrogaInput!]!
    ){
        createProrrogas(input: $input){
            success,
            error,
            valorEsperado
        }
    }
`;